import { FormFieldTypes } from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import { IMultiChoiceFieldOptionsClient } from "@presentation/FormBuilder/components/FormMultipleChoicesField/interface";
import { IPanelSelectedSubmissionValue } from "@presentation/FormBuilder/components/FormDoublePanelField/interface";
import { IEmailActionConfig, IFormsMap } from "../forms/interface";
import {
  IFieldLevelRuleServer,
  IFormLevelRuleServer,
  IPageLevelRuleServer,
} from "../formBuilder/interface";
import { IOption } from "@erelego/design-system/components/atoms";
interface IDataGridMapping {
  [key: string]: string[];
}
export interface IDatagridValue {
  datagridFields: string[];
  datagridMapping: IDataGridMapping;
}
export interface IFormSubmission {
  localId: string;
  fieldSubmissionMap: IFieldSubmissionMap;
  fieldType?: FormFieldTypes | string;
  submissionId?: string;
  submittedDate?: string;
  duplicateValueExist?: boolean;
  isCompositeKeySuccess?: boolean;
  compositeFieldSubmissionMap?: any;
}
export interface IRespondedBySubmissionData {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  reportingManager: string;
  designation: string;
  department: string;
  attributes: string;
  createdById: string;
  makerLevel?: number;
  makerEmail?: string;
  updatedByLevel?: number;
  updatedByEmail?: string;
}
export interface IRespondedBySubmissionMap {
  [submissionId: string]: IRespondedBySubmissionData;
}
export interface IFieldSubmissionMap {
  [fieldId: string]: IFormFieldSubmission;
  // action?: string;
}
export interface IUniversalStorageData {
  [key: string]: any;
}
export interface IDefaultProfilesMap {
  [key: string]: any;
}
export interface ISetSubmissionType {
  isDraft: boolean;
}
export interface IFormFieldSubmission {
  localId: string;
  fieldType?: FormFieldTypes | string;
  fieldSubmissionValue?: ISubmissionFieldDataClient; // in clientSide handeled as value: "string" || selectedOption: "string" || selectedOptions: IMultiChoiceFieldOptionsClient || uploadedFiles: string[]
  isError?: boolean;
  valueError?: string;
  isSection?: boolean;
  action?: string;
  columnId?: string;
  isDisabled?: boolean;
}

export interface ISubmissionFieldDataClient {
  value?: string;
  selectedOption?: any; // dropdown and linearScaling and single selection
  selectedOptions?: IMultiChoiceFieldOptionsClient[]; //multiselect
  uploadedFiles?: string[]; //uploadfiles
  checkBoxValue?: string;
  paymentValue?: IPaymentSubmissionValue;
  geolocationValue?: IGeolocationSubmissionValue;
  dataGridValue?: ITableSubmissionMap;
  manualSignatureData?: string;
  panelSelectedItemList?: IPanelSelectedSubmissionValue[]; //adding submission value
  buttonValue?: string;
  bannerValue?: string;
}

export interface ITableSubmissionMap {
  [columnId: string]: IFieldSubmissionMap;
}

export interface IPaymentSubmissionValue {
  amount: string;
  selectedPaymentId: string;
  gateway: string;
  userEmail: string;
  phoneNumber: string;
  checkBoxValue?: string;
  paymentGateway?: string;
  status?: string;
  orderId?: string;
  updatedDate?: string;
}

export interface IGeolocationSubmissionValue {
  latitude?: string;
  longitude?: string;
  address?: string;
}

export interface IFormSubmissionMap {
  [formId: string]: string[];
}
export interface ISubmissionMap {
  [submissionId: string]: IFormSubmission;
}

export interface IDataGridActionsMapper {
  [fieldId: string]: {
    [submissionId: string]: string;
  };
}
export interface IDataGridCompositeKeysValidationMapper {
  [submissionId: string]: string;
}
export interface ILinkedFieldPayload {
  fieldIds: string[];
}
export interface linkedFiledOptions {
  [fieldId: string]: IOption[];
}
export interface ILinkedFieldOptions {
  [fieldType: string]: linkedFiledOptions;
}

export interface ILookupOptionsState {
  optionsMap: {
    [fieldId: string]: IOption[];
  };
}
export interface IFormSubmissionReducerState {
  activeFormSubmission: IFormSubmission;
  activeFormCompositeKeySubmission: IFormSubmission;
  isDraftSubmission: boolean;
  universalStorageUnit: IUniversalStorageData;
  isFormBuilderAsComponent: boolean;
  formSubmissionMap: IFormSubmissionMap;
  referenceCopyFormSubmissionMap: IFormSubmissionMap;
  formSubmissionsPaginationMap: IFormSubmissionsPaginationMap;
  submissionMap: ISubmissionMap;
  respondedByDetails: IRespondedBySubmissionMap;
  isPreview: boolean;
  formSubmissionSettingsMap: IFormSubmissionSettingsMap;
  mySubmissions: IMySubmissions;
  dataGridActionsMapper: IDataGridActionsMapper;
  dataGridTableValues?:   {
    [fieldId: string]: ITableSubmissionMap;
  };
  dataGridCompositeKeysValidationMapper: IDataGridCompositeKeysValidationMapper;
  isSamePage: boolean;
  visitedPages:string[];
  linkedFieldsToLookup: string[];
  linkedFieldLookupOptions: ILinkedFieldOptions;
  mappedLookupOptions: ILookupOptionsState,
  loaders: {
    addFormSubmission: boolean;
    addFormBulkSubmission: boolean;
    fetchFormSubmissions: boolean;
    deleteFormSubmission: boolean;
    deleteDatagridFormSubmission: boolean;
    updateFormSubmission: boolean;
    fetchFormSubmissionSettings: boolean;
    fetchMySubmissions: boolean;
    setActiveFormSubmission: boolean;
    checkDuplicateSubmission: boolean;
  };
  errors: {
    addFormSubmission: string;
    addFormBulkSubmission: string;
    fetchFormSubmissions: string;
    deleteFormSubmission: string;
    deleteDatagridFormSubmission: string;
    updateFormSubmission: string;
    fetchFormSubmissionSettings: string;
    fetchMySubmissions: string;
    fetchSubmissionBySubmissionId: string;
    checkDuplicateSubmission: string;
  };
  openedDate?: number;
  otpResponse: OtpResponseItem[] | null,
  otpLoading: boolean,
  otpError: string,
}

export interface OtpResponseItem {
  requester: string;
  requesterType: string;
  status: string;
  message: string;
}

export interface IFormSubmissionsPaginationMap {
  [formId: string]: IFormSubmissionPagination;
}

export interface IFormSubmissionSettingsMap {
  [formId: string]: IFormSubmissionSettings;
}

export interface IFormSubmissionSettings {
  isMultipleSubmissionAllowed?: boolean;
}

export interface IFormSubmissionPagination {
  pageNumber?: number;
  totalElements?: number;
  totalPages?: number;
  pageSize?: number;
}

export interface ISubmissionFormDataServer {
  id?: string; //submissionId
  formId: string;
  formData: ISubmissionFormFieldDataServer;
  respondedBy?: IRespondedBySubmissionData;
  createdDate?: string;
  userId?: string;
  isDraft?: boolean;
  relatedSubmissionIds?: string[];
  openedDate?: number;
  makerEmail?: string;
  makerLevel?: number;
  updatedByEmail?: string;
  updatedByLevel?: number;
}
export interface IBulkSubmissionFormDataServer {
  formDataDtoList: ISubmissionFormDataServer[];
}
export interface IBulkSubmissionFormDataServer {
  formDataDtoList: ISubmissionFormDataServer[];
}

export interface IFetchFormSubmissionsApiResponse {
  content?: ISubmissionFormDataServer[];
  numberOfElements?: number;
  pageNumber?: number;
  pageSize?: number;
  totalElements?: number;
  totalPages?: number;
  first?: boolean;
  last?: boolean;
  empty?: boolean;
}

export interface IFetchFormSubmissionsSuccessPayload {
  response?: IFetchFormSubmissionsApiResponse;
  fetchedFormsMap?: IFormsMap;
}

export interface ISubmissionFormFieldDataServer {
  [fieldId: string]: ISubmissionFieldDataServer;
}

export type ISubmissionFieldDataServer =
  | IPaymentSubmissionData
  | IGeolocationSubmissionValue
  | (string | string[])
  | boolean
  | number
  | ITableSubmissionMapServer
  | IMultiChoiceFieldOptionsClient[] //all field values type is string only multiselect and multiple files is string[] checkBox is boolean
  | IPanelSelectedSubmissionValue[];

export interface ITableSubmissionMapServer {
  [columnId: string]: ISubmissionFormFieldDataServer;
}
export interface IPaymentSubmissionData {
  paymentGateway?: string;
  orderId?: string;
  bankTxnId?: string;
  txnAmount?: number;
  paymentMethod?: string;
  status?: string;
  createdDate?: number;
  updatedDate?: any;
}
export interface IFetchFormSubmissionsAction {
  type: string;
  payload: IFetchFormSubmissionsPayload;
}
export interface IFetchPinCode {
  type: string;
  payload: IFetchPicodePayload;
}

export interface IFetchFormSubmissionsPayload {
  formIds: string[];
  pageNumber: number;
  pageSize?: number;
}
export interface IFetchPicodePayload {
  pincode: string;
  countryCode: string;
  onSuccessPincodeData: (response: any) => void;
  onFailure: (ErrorText: string) => void;
}

export interface IFetchFormSubmissionsDataToExportPayload {
  formId: string;
  onSuccessFileFetch: (response: any) => void;
  onFailureFileFetch: (ErrorText: string) => void;
  fromDate?: number; //string;
  toDate?: number; // string;
  fileType?: string;
}

export interface IFetchFormSubmissionsDataToExportAction {
  type: string;
  payload: IFetchFormSubmissionsDataToExportPayload;
}

export interface IFetchFormSubmissionsDataToExportRepositoryPayload {
  formId: string;
  fromDate?: number; // string;
  toDate?: number; // string;
  fileType?: string;
}

export interface IMySubmittedFormsDetailsServer {
  name?: string;
  title?: string;
}

export interface IFetchMySubmissionsPayload {
  pageNumber: number;
  pageSize: number;
}

export interface IFetchMySubmissionAction {
  type: string;
  payload: IFetchMySubmissionsPayload;
}

export interface IMySubmissionToFormMap {
  [submissionId: string]: string;
}

export interface IMySubmissions {
  mySubmissionpaginationData: IFormSubmissionPagination;
  mySubmissionIds: string[];
}

export interface IFetchFormSubmissionSettingsAction {
  type: string;
  payload: { formId: string };
}

export interface IFetchSubmissionBySubmissionId {
  type: string;
  payload: { submissionId: string,roleName?:string };
}

export interface IFetchFormSubmissionSettingsSuccessActionPayload {
  isMultipleSubmissionAllowed: boolean;
  formId?: string;
}

export interface IFetchFormSubmissionSettingsFailureActionPayload {
  isMultipleSubmissionAllowed?: boolean;
  formId?: string;
  error?: string;
}

export interface IDuplicateCheckFormData {
  formId: string;
  fieldDetails: IDuplicateCheckFieldData[];
  submissionId?: string;
  compositeFieldDetails: IDuplicateCheckFieldData[];
  updatedHiddenFields?: [];
}

export interface IDuplicateCheckFieldData {
  localId: string;
  value: string | number | IMultiChoiceFieldOptionsClient[];
}

export interface ICheckDuplicateSubmissionResponse {
  formId: string;
  fieldDetails: ICheckDuplicateSubmissionFieldResponse[];
  isCompositeFieldsDuplicate: boolean;
  compositeFieldDetails: ICheckDuplicateSubmissionFieldResponse[];
}
export interface ICheckDuplicateSubmissionFieldSuccessResponsePayload {
  fieldData: ICheckDuplicateSubmissionFieldResponse[];
  isCompositeFieldsDuplicate: boolean;
  compositeFieldData: ICheckDuplicateSubmissionFieldResponse[];
}

export interface IResetCompositeKeyDuplicateResponse {
  isCompositeFieldsDuplicate: boolean;
}
export interface ICheckDuplicateSubmissionFieldResponse {
  localId: string;
  isDuplicate: boolean;
}

export interface ICompositeKeyFieldResponse {
  compositeFieldSubmissionMap: IDuplicateCheckFieldData;
  isCompositeKeySuccess: boolean;
}

export interface IQRCodeData {
  qrCodeFieldId: string;
  qrCodeBase64: string;
}
export interface IAddFormSubmissionPayload {
  formId: string;
  formSubmissionSuccessCallback: (
    formSubmissionData: ISubmissionFormDataServer
  ) => void;
  formSubmissionFailureCallback: (error: string) => void;
  id?: string;
  isSaveInDraft?: boolean;
  relatedSubmissionIds: string[];
  qrcodeData?: IQRCodeData;
  openedDate?: number;
  roleName?: string;
}

export interface IAddFormBulkSubmissionPayload {
  formDataDtoList: IAddFormSubmissionPayload[];
}

export interface IWorkflowServer {
  id?: string;
  formId: string;
  applicationId: string;
  updatedDate?: string;
  createdDate?: string;
  isEnabled: boolean;
  workflow: IWorkflowServerConfig;
}
export interface IWorkflowServerConfig {
  id?: string;
  name?: string;
  formId?: string;
  rules?: {
    fieldRules?: IFieldLevelRuleServer[];
    formRules?: IFormLevelRuleServer[];
    pageRules?: IPageLevelRuleServer[];
    submissionRules?: any[]; // have to update
  };
  event?: Events;
  eventCondition?: EventCondition; //PRE_FORM_SUBMISSION;
  workFlowPerformDataAction?: IWorkflowPerformDataAction;
  workFlowNotifications?: IWorkflowNotification;
  eventData?: IEventData;
  workFlowExternalIntegration?: any;
}
export interface IEventData {
  eventType?: string;
  loadFormScript?: ILoadFormCustomScript;
  onFormSubmissionCustomScript?: IFormSubmissionCustomScript;
  fieldInputScript?: IFieldInputscript;
}
export interface IFormSubmissionCustomScript {
  script?: string;
}
export interface ILoadFormCustomScript {
  script?: string;
}

export interface IFieldInputscript {
  script?: string;
  fieldId?: string;
}

export enum Events {
  CREATED = "CREATED",
  EDITED = "EDITED",
  DELETED = "DELETED",
  CREATEDEDITED = "CREATEDEDITED",
}
export enum EventCondition {
  PRE_FORM_SUBMISSION = "PRE_FORM_SUBMISSION",
  ON_FORM_SUBMISSION = "ON_FORM_SUBMISSION",
  POST_FORM_SUBMISSION = "POST_FORM_SUBMISSION",
}

export interface IWorkflowPerformDataAction {
  addRecord: {
    formId: string;
    mapFields: any;
  };
  updateRecord: any;
  deleteRecord: any;
}

export interface IWorkflowNotification {
  sendEmail: IEmailActionConfig;
  sendSms: {
    to: string;
    message: string;
  };
  sendWhatsApp: {
    to: string;
    message: string;
  };
  notification: {
    to?: {
      type?: string;
      value?: string;
    };
    message?: string;
  };
  redirectToUrl: {
    link: string;
    openIn: string; //SAME_WINDOW;
    urlType: string; //WEBSITE
  };
}

// --------------------------------------------------------

export interface IEventConditionOption {
  title: string;
  value: EventCondition;
}
export interface IEventsOption {
  title: string;
  value: Events;
}

export interface IEventsTypeOption {
  title: string;
  value: string;
  caption?: string;
}

export interface IWorkflowNotification {
  sendEmail: IEmailActionConfig;
  sendSms: {
    to: string;
    message: string;
  };
  sendWhatsApp: {
    to: string;
    message: string;
  };
  notification: {
    to?: {
      type?: string;
      value?: string;
    };
    message?: string;
  };
  redirectToUrl: {
    link: string;
    openIn: string; //SAME_WINDOW;
    urlType: string; //WEBSITE
  };
}

export interface IOtpRequest {
    requester: string;
    requesterType: string;
    otpSource: string;
    otpType: string;
    otp?: string;
}

export enum RequesterType {
  EMAIL = 'EMAIL',
  MOBILE = 'MOBILE',
}

export enum OtpSource {
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
}

export enum OtpType {
  NUMERIC = 'NUMERIC',
}